module.exports = __webpack_public_path__ + "static/media/barbell-plate-2500.5fd6e8dc.png";